import { useEffect, useState } from "react";
//import AdvancedDeruptar from "../avatar/AdvancedDeruptar";
import NFTAvatar from "../avatar/NFTAvatar";
import ViewOGBadge from "../avatar/ViewOGBadge";
import { Card, CardContent, Typography, CardActions, CardHeader } from '@mui/material';
import { getNames } from "../../services/stacks";

import './style.scss';


const Gifts = ({ giftsData, currencies, userSettings }) => {
    const [name, setName] = useState('');
    const [decodedMemo, setDecodedMemo] = useState('');
    const [refactoredAmount, setRefactoredAmount] = useState(0);
    const [icon, setIcon] = useState('');
    const [chimeAuthor, setChimeAuthor] = useState('');

    // Page redirect function
    function redirectToProfile(val) {
        window.location.replace(`/${val}`);
    }

    // Function to convert a hexadecimal string to a Uint8Array
    function hexStringToUint8Array(hexString) {
        const result = new Uint8Array(hexString.length / 2);
        for (let i = 0; i < hexString.length; i += 2) {
            result[i / 2] = parseInt(hexString.substr(i, 2), 16);
        }
        return result;
    }

    // Function to load Gift data to render
    async function loadGiftInfo() {
        const { memo: memoHex, amount, chimeAuthor, isStx } = giftsData;
        const { names } = await getNames(chimeAuthor);

        // Memo conversion from buff to human readable string
        const memoBytes = hexStringToUint8Array(memoHex);
        const decoder = new TextDecoder('utf-8');
        const decodedMemo = decoder.decode(memoBytes);
        const trimmedDecodedMemo = decodedMemo.slice(1);

        // Find Gifted token in currencies const to determine token icon and decimal
        // If token isn't a recognized token from currencies const, default token icon and decimalfactor is set
        const { icon, decimalfactor } = currencies.find((currency) => {
            if (isStx.value) {
                if (currency.value === 'stx') return currency;
            } else {
                if (giftsData.contractId === currency.contractName) return currency;
            }
            return true;
        });

        setName(names[0]);
        setDecodedMemo(trimmedDecodedMemo);
        setRefactoredAmount(amount / decimalfactor);
        setIcon(icon ? icon : '/32-default.png');
        setChimeAuthor(chimeAuthor);
    }

    useEffect(() => {
        loadGiftInfo();
    }, []);

    return (
        <div className="gift-container">
            {chimeAuthor && name &&
                < Card sx={{ maxWidth: '100%' }} id="gift-card">
                    <CardHeader
                        id="gift-card-header"
                        avatar={
                            <div id="avatar" onClick={() => redirectToProfile(chimeAuthor)}>
                                <NFTAvatar authorPrincipal={chimeAuthor} authorName={name} userSettings={userSettings} />
                                {/* <AdvancedDeruptar authorPrincipal={chimeAuthor} className="deruptar-profile" alt="deruptar" /> */}
                                <div id="ogcheck-gift-container">
                                    {chimeAuthor && <ViewOGBadge authorPrincipal={chimeAuthor} userSettings={userSettings} />}
                                </div>
                            </div>
                        }
                        title={name}
                        subheader={chimeAuthor.substring(0, 5) + '...' + chimeAuthor.substring(chimeAuthor.length - 5)}
                    />
                    <CardContent id="gift-card-memo">
                        <Typography variant="body1">{decodedMemo}</Typography>
                    </CardContent>
                    <CardActions disableSpacing id="gift-card-actions">
                        <img src={icon} id="gift-token-icon" alt=""/>
                        <Typography variant="body1">{refactoredAmount}</Typography>
                    </CardActions>
                </Card>
            }
        </div >
    )
}

export default Gifts;